export const cartConstants = {
  ADD_TICKET: "ADD_TICKET",
  DELETE_TICKET: "DELETE_TICKET",
  ADD_ORDER_ID: "ADD_ORDER_ID"
};
